var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, Prop, EventEmitter, Event, html, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Tabs.style';
export
/**
 * A DaVinCi-Tabs shows a tab bar which is used to switching between various content tab's.
 * @example
 * ```html
 *    <davinci-tabs>
 *        <davinci-tab title="Tab1">any content</davinci-tab>
 *        <davinci-tab selected title="Tab2">any other</davinci-tab>
 *    </davinci-tabs>
 * 
 *    <davinci-tabs type="classic">
 *        <davinci-tab title="Tab1">any content</davinci-tab>
 *        <davinci-tab selected title="Tab2">any other</davinci-tab>
 *    </davinci-tabs>
 * ```
 * @slot {davinci-tab[]} tabs dispalyed within tab control
 */
let Tabs = (_dec = Component({
  tag: 'davinci-tabs',
  style: [style]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Event('tab-change'), _dec9 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec10 = Event('close-tab'), _dec11 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec(_class = (_class2 = (_temp = class Tabs extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "closeable", _descriptor2, this);

    _initializerDefineProperty(this, "tabChange", _descriptor3, this);

    _initializerDefineProperty(this, "closeTab", _descriptor4, this);

    this.list = new Array();
    this._index = 0;
    this.isFirstRender = true;
  }

  /**
   * Get the index of the selected tab.
   */
  set selectedIndex(index) {
    this._select(index);

    this.tabChange.emit(index);
  }

  get selectedIndex() {
    return this._index;
  }
  /**
   * Emitted if the user changes the selected tab.
   */


  render() {
    return html`
    <div class="titles">
        ${this.list.map((v, i) => html`
          <span class="headline" id=${i} ?selected=${this._index === i} @click=${this._onClick}>
            ${v.renderIcon()}
            <span class="title">${v.title}</span>
            ${this._renderCloseIcon()}
          </span>
        `)}
        <div class="rest"></div>
		</div>
    <div class="tabs">
      <slot @slotchange="${this._generateList}"></slot>
    </div>`;
  }

  componentDidRender() {
    // Safari (does not call @slotchange from above) fix -- https://github.com/whatwg/dom/issues/447
    if (this.isFirstRender) {
      this.isFirstRender = false;

      this._generateList();
    }
  }

  _onClick(e) {
    const tab = e.target.classList.contains('headline') ? e.target : e.target.parentElement;
    this.selectedIndex = +tab.id;
  }

  _onClickClose(e) {
    e.stopPropagation();
    const index = +e.target.parentElement.id;
    this.list.splice(index, 1);

    this._removeTabFromDom(index);

    if (this.selectedIndex === index) {
      this.selectedIndex = this.list.length === index ? +index - 1 : +index;
    }

    this.scheduleRender(true);
  }

  _removeTabFromDom(tabIndex) {
    const tabElements = Array.from(this.querySelectorAll('davinci-tab'));
    this.removeChild(tabElements[tabIndex]);
    this.closeTab.emit(tabIndex);
  }

  _select(index) {
    this._index = index;
    this.list.forEach((v, i) => {
      v.selected = i === index;
    });
  }

  _generateList() {
    const slotElement = this.shadowRoot.querySelector('slot');
    const slotAssignedNodes = slotElement.assignedNodes();
    this.list = slotAssignedNodes.filter(node => node.nodeName.toLowerCase() === 'davinci-tab').map((v, i) => {
      this._index = v.selected ? i : this._index;
      v.index = i;
      return v;
    });

    this._select(this._index);

    this.scheduleRender(true);
  }

  _renderCloseIcon() {
    if (this.type === 'classic' && this.closeable) {
      return html`<davinci-icon class="close" icon='navigation/close' @click=${this._onClickClose}></davinci-icon>`;
    } else {
      return html`${nothing}`;
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'modern-heavy';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "closeable", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "selectedIndex", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedIndex"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "tabChange", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "closeTab", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
//# sourceMappingURL=Tabs.js.map